export enum ColorScheme {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system',
}

export type ColorSchemeType = ColorScheme.LIGHT | ColorScheme.DARK
